import ConnectorDealsNew from './deals/ConnectorDealsNew';
import ConnectorDealsInProgress from './deals/ConnectorDealsInProgress';
import ConnectorDealsDone from './deals/ConnectorDealsDone';
import ConnectorTabsBar from './deals/ConnectorTabsBar';

export { ConnectorDealsNew, ConnectorDealsInProgress, ConnectorDealsDone, ConnectorTabsBar };

export default { ConnectorDealsNew, ConnectorDealsInProgress, ConnectorDealsDone, ConnectorTabsBar };

